import type {
  InfrastructureDistance,
  ReportSubject,
} from "../../ReportComponent/model/types";
import { DataTable, INK, Lead, SubTitle, Unavailable, nf } from "./primitives";

const GROUP_TITLE: Record<InfrastructureDistance["group"], string> = {
  energia: "Energia",
  logistica: "Logística e insumos",
};

export function InfrastructureSection({
  subject,
  systemMode,
}: {
  subject: ReportSubject;
  systemMode: "sin" | "distribuidora";
}) {
  return (
    <>
      <SubTitle>Infraestrutura e contexto</SubTitle>
      <Lead>
        Distância em linha reta da borda da área à feição mais próxima de cada rede
        {systemMode === "sin"
          ? " (rede elétrica do SIN)"
          : " (rede elétrica da distribuidora Neoenergia)"}
        . Distância zero indica que a feição cruza a área.
      </Lead>
      {subject.infrastructure.length === 0 ? (
        <Unavailable what="Distâncias à infraestrutura" />
      ) : (
        <DataTable
          columns={[
            {
              header: "Infraestrutura",
              render: (d: InfrastructureDistance) => d.label,
              width: "34%",
            },
            { header: "Grupo", render: (d) => GROUP_TITLE[d.group] },
            {
              header: "Feição mais próxima",
              render: (d) => (
                <span style={{ color: INK.secondary }}>{d.featureName ?? "—"}</span>
              ),
            },
            {
              header: "Distância",
              align: "right",
              render: (d) =>
                d.distanceKm == null ? "não encontrada" : `${nf(d.distanceKm, 1)} km`,
            },
          ]}
          rows={subject.infrastructure}
          rowKey={(d) => d.id}
        />
      )}
      <p className="text-[0.8rem] mt-2" style={{ color: INK.primary }}>
        <span className="font-semibold">Vocação principal do município (ADEPE): </span>
        {subject.vocacaoPrincipal
          ? `${subject.vocacaoPrincipal.nome}${
              subject.vocacaoPrincipal.maturidade
                ? ` — ${subject.vocacaoPrincipal.maturidade}`
                : ""
            }`
          : "não informada"}
        {subject.municipalityName ? ` (${subject.municipalityName})` : ""}
      </p>
    </>
  );
}
